import type { SupabaseClient } from "@supabase/supabase-js";
import { createClient } from "@supabase/supabase-js";

let supabaseClient: SupabaseClient | null = null;

/**
 * Retorna o endpoint corporativo nativo (/api/v1).
 * Dessa forma, o nome 'supabase' e URLs externas são 100% eliminados do navegador.
 */
export const getSupabaseUrl = (): string => {
  if (typeof window !== "undefined" && window.location) {
    return `${window.location.origin}/api/v1`;
  }
  return "/api/v1";
};

export const getSupabaseAnonKey = (): string => {
  return import.meta.env.VITE_SB_PUBLISHABLE_KEY || "";
};

export const getSupabaseClient = () => {
  if (!supabaseClient) {
    supabaseClient = createClient(getSupabaseUrl(), getSupabaseAnonKey(), {
      auth: {
        storageKey: "dotus_crm_session",
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
      },
    });
  }
  return supabaseClient;
};
